import React from 'react';
import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiStar } = FiIcons;

const Reviews = () => {
  const reviews = [
    {
      name: "Priyanka S",
      rating: 5,
      time: "5 months ago",
      text: "Tried their Strawberry Cup and the classic Zalabya, both of which showcase the restaurant's dedication to quality and authenticity."
    },
    {
      name: "Nidaie",
      rating: 5,
      time: "3 months ago",
      text: "Amazing zalabya. I dont have a photo of my zalabya as i pounced on them as soon as my order arrived. Perfect crispy outer layer and soft chocolate filled inside feels and tastes really really good. I will be having them many times again."
    },
    {
      name: "Yasmine M.",
      rating: 5,
      time: "2 months ago",
      text: "A delicious twist on a traditional Egyptian dessert known as 'Loumat il Audi'! Freshly made deep-fried dough of crispy crunchy puffs! These are then smothered with WARM delicious liquid milk chocolate (half) & warm sweet liquid pistachio"
    },
    {
      name: "Kelsey Brown",
      rating: 5,
      time: "6 months ago",
      text: "Came here for the Dubai chocolate strawberry cup. Absolutely fantastic! Great size and value for what it cost. Abundance of fresh juicy strawberries. The filling was delicious and perfect. Will definitely return for this treat and highly"
    },
    {
      name: "Aicha E",
      rating: 5,
      time: "2 months ago",
      text: "I came here for the first time and tried the viral dubai strawberry cup with icecream, it was AMAZING. Ive tried almost all the strawberry cups and this one by far was my favourite. Its lighter than most & the staff was so generous with the"
    },
    {
      name: "aline",
      rating: 5,
      time: "5 months ago",
      text: "very friendly workers and the best fried puffs ever!!! Ive had fried puffs from other places, but they don't load them with sauce and toppings like Zalabya does!! their strawberry chocolate cups are super good too and filled to the top!! I've recommended zalabya to so many of my friends and they all love it ❤️❤️"
    },
    {
      name: "Lena Adada",
      rating: 5,
      time: "a month ago",
      text: "Zalabya dessert is simply amazing! The taste is out of this world – perfectly crisp on the outside and soft on the inside, with just the right amount of sweetness. Every bite melts in your mouth! The quality is always top-notch, and you can"
    },
    {
      name: "MI",
      rating: 5,
      time: "4 months ago",
      text: "Our favorite dessert spot.Kids love their new dubai chocolate cup and dubai cake. We also tried mint mojito its refreshing."
    },
    {
      name: "Hadia",
      rating: 5,
      time: "4 months ago",
      text: "Absolutely heavenly experience. Mouth watering, crunchy, chocolatey and delicious. Bit on the pricey side but totally worth trying !"
    },
    {
      name: "Andrew Kaldas",
      rating: 5,
      time: "2 weeks ago",
      text: "Best zalabya spot in the GTA!!! Peter (the owner) is a great guy. Service is top notch and the flavour vs. value is unbeatable. Must try if you're ever in the GTA."
    },
    {
      name: "Dalia",
      rating: 4,
      time: "6 months ago",
      text: "Great quick dessert spot if you're looking on the go. Oil is renewed often and is packed with the sauce on top. The service is fairly quick and is very kind. 10/10 worth a try. - salted caramel is amazing"
    },
    {
      name: "Riona Tahani",
      rating: 5,
      time: "3 months ago",
      text: "The best Dubai chocolate place in town! A bar for $5.99, and the dubai chocolate strawberry cup is also a very good price. There's so many different dessert options and this place should be much more popular. Service was very fast. Please go here its a hidden gem"
    }
  ];

  const renderStars = (rating) => {
    return Array.from({ length: 5 }, (_, index) => (
      <SafeIcon
        key={index}
        icon={FiStar}
        className={`w-4 h-4 ${
          index < rating ? 'text-yellow-400 fill-current' : 'text-gray-400'
        }`}
      />
    ));
  };

  return (
    <>
      <Helmet>
        <title>Reviews - Zalabya | Customer Reviews & Testimonials</title>
        <meta name="description" content="Read what our customers say about Zalabya's authentic Egyptian desserts. 5-star reviews for our zalabya, Dubai chocolate, and exceptional service in Mississauga." />
      </Helmet>

      <div className="pt-24 pb-12">
        <div className="container mx-auto px-4">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center mb-12"
          >
            <h1 className="text-5xl font-bold text-gradient mb-4">Customer Reviews</h1>
            <p className="text-xl text-gray-300 max-w-2xl mx-auto">
              See what our happy customers are saying about their Zalabya experience
            </p>
          </motion.div>

          {/* Stats Section */}
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16"
          >
            <div className="card p-8 text-center">
              <div className="text-4xl font-bold text-yellow-400 mb-2">4.8</div>
              <div className="flex justify-center mb-2">
                {renderStars(5)}
              </div>
              <p className="text-gray-300">Average Rating</p>
            </div>
            <div className="card p-8 text-center">
              <div className="text-4xl font-bold text-pink-400 mb-2">500+</div>
              <p className="text-gray-300">Happy Customers</p>
            </div>
            <div className="card p-8 text-center">
              <div className="text-4xl font-bold text-yellow-400 mb-2">95%</div>
              <p className="text-gray-300">5-Star Reviews</p>
            </div>
          </motion.div>

          {/* Reviews Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {reviews.map((review, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className="card p-6"
              >
                <div className="flex items-start justify-between mb-4">
                  <div>
                    <h3 className="font-bold text-yellow-400 text-lg">{review.name}</h3>
                    <p className="text-gray-400 text-sm">{review.time}</p>
                  </div>
                  <div className="flex">
                    {renderStars(review.rating)}
                  </div>
                </div>
                <p className="text-gray-300 leading-relaxed">{review.text}</p>
              </motion.div>
            ))}
          </div>

          {/* Call to Action */}
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center mt-16"
          >
            <h2 className="text-3xl font-bold text-yellow-400 mb-6">Ready to Create Your Own Review?</h2>
            <p className="text-xl text-gray-300 mb-8 max-w-2xl mx-auto">
              Join our satisfied customers and experience the authentic taste of Egyptian desserts
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a href="/contact" className="btn-primary">
                Visit Us Today
              </a>
              <a href="/menu" className="btn-secondary">
                View Our Menu
              </a>
            </div>
          </motion.div>

          {/* Google Reviews Link */}
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center mt-12"
          >
            <p className="text-gray-400 mb-4">Want to see more reviews?</p>
            <a
              href="https://maps.app.goo.gl/UKjdkNcxDo6BqAQTA"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-secondary"
            >
              View on Google Maps
            </a>
          </motion.div>
        </div>
      </div>
    </>
  );
};

export default Reviews;